<template>
  <div style="background-color: transparent; height: 100vh; padding: 6px">
    <h4 v-if="AreIdsShown">DASH 2 new</h4>
    <h6 v-if="AreIdsShown">currentSelectedWorkSummaryWidget {{ workListStore.currentSelectedWorkSummaryWidget.id }} {{ workListStore.currentSelectedWorkSummaryWidget.name }}</h6>
    <!-- <br> -->
    <h6 v-if="AreIdsShown">currentSelectedWorkSummaryWidget.selectedTaskTypeFilters {{ workListStore.currentSelectedWorkSummaryWidget.selectedTaskTypeFilters }}</h6>

    <div style="background: transparent; padding: 0px; height: 100%; width: 100%; overflow: hidden">
      <DxSplitter width="100%" height="100%" :separator-size="20" orientation="vertical">
        <DxItem :resizable="false" :collapsible="false" size="200" :min-size="100" :max-size="400">
          <div style="background: transparent; height: 100%; width: 100%; overflow: hidden">
            <!-- <span>TESTING</span> -->
            <WidgetSummaryListWork :key="componentKey" />
          </div>
        </DxItem>
        <DxItem :collapsible="false">
          <DxSplitter width="100%" height="100%" :separator-size="10">
            <DxItem :resizable="false" :collapsible="false" :size="[12, 13].includes(workListStore.currentSelectedSummaryWidget.id) ? '600' : '600'">
              <div style="background: transparent; height: 100%">
                <WidgetSummaryContainerWork @doForceRender="forceRerender()" />
              </div>
            </DxItem>
            <DxItem :resizable="true" :collapsible="false">
              <div>
                <!-- {{ workListStore.currentSelectedWorkSummaryWidget.id }} -->
                <div
                  v-show="[12, 13].includes(workListStore.currentSelectedWorkSummaryWidget.id)"
                  style="background: transparent; padding: 0px; border-radius: 3px; width: 100%; overflow: hidden; height: 100%"
                >
                  <!-- <b-button @click="forceRerender()" variant="danger">forceRerender </b-button> componentKey {{ componentKey }} -->
                  <!-- <h4 style="color: red">WidgetSummaryDetailGridWork</h4> -->
                  <WidgetSummaryDetailGridWork
                    :key="componentKey"
                    v-if="workListStore.currentSelectedWorkSummaryWidget.id > 0"
                    :arrayId="workListStore.currentSelectedWorkSummaryWidget.id"
                    :records="workListStore.currentSelectedWorkSummaryWidget.widgetGridDataArray"
                    :selectedFileName="workListStore.currentSelectedWorkSummaryWidget.exportFileName"
                    idField="id"
                    @refreshToParent="forceRerender()"
                  />
                </div>
                <div
                  v-show="[14, 15].includes(workListStore.currentSelectedWorkSummaryWidget.id)"
                  style="background: transparent; padding: 0px; border-radius: 3px; width: 100%; overflow: hidden; height: 98.5%"
                >
                  <!-- <h4 style="color: red">OTHER</h4> -->
                  <WidgetSummaryDetailOtherGrid
                    v-if="workListStore.currentSelectedWorkSummaryWidget.id > 0"
                    :arrayId="workListStore.currentSelectedWorkSummaryWidget.id"
                    :records="workListStore.currentSelectedWorkSummaryWidget.widgetGridDataArray"
                    :selectedFileName="workListStore.currentSelectedWorkSummaryWidget.exportFileName"
                    idField="id"
                  />
                </div>
              </div>
            </DxItem>
          </DxSplitter>
        </DxItem>
      </DxSplitter>
    </div>


  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, toRaw } from "vue";
import { useStoreWorkList } from "@/stores/workListsStore";

import { DxSplitter, DxItem } from "devextreme-vue/splitter";

import WidgetSummaryContainerWork from "@/modules/WorkLists/WidgetSummaryContainerWork.vue";
import WidgetSummaryListWork from "@/modules/WorkLists/WidgetSummaryListWork.vue";

import WidgetSummaryDetailGridWork from "@/modules/WorkLists/WidgetSummaryDetailGridWork.vue";
import WidgetSummaryDetailOtherGrid from "@/modules/WorkLists/WidgetSummaryDetailOtherGrid.vue";

const AreIdsShown = ref(false);
const workListStore = useStoreWorkList();
const componentKey = ref(0);

function forceRerender() {
  // console.clear()
  // console.log("    DASH TWO      forceRerender >>  KEY CHANGE on   ............");
  this.componentKey += 1;
  // console.log(toRaw(this.componentKey));
}

onMounted(() => {
  // console.clear()
  // console.log(" 		DASHBOARD PAGE 			TWO");
});
</script>

<style lang="scss" scoped>
.btn {
  &:hover + .box {
    transform: scale(2);
  }
}

.btn.selected {
  color: red;
}

.box {
  transition: transform 330ms ease-in-out;
}

.btn-secondary:hover {
  color: #17b3be;
  background-color: #1adb23;
  transform: scale(1.4);
  transition: transform 330ms ease-in-out;
}

.transform-me {
  margin-left: 100px;
}

.transform-me:hover {
  transform: scale(1.2);
}

#bFormContainer {
  background: rgba(0, 255, 234, 0.645);
  padding: 13px;
  width: 50%;
  height: 50%;
  overflow: auto;
  border-radius: 25px;
}

#tagContainer {
  background: rgb(55, 65, 65);
  padding: 3px;
  height: 83vh;
  border: 3px solid orange;
  padding: 10px;
  border-radius: 25px;
}

.visibleA {
  visibility: visible;
  opacity: 1;
  transition: opacity 2s linear;
}

.hiddenA {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s 2s, opacity 2s linear;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.25);
  }

  100% {
    transform: scale(1);
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.my-custom-tags-list2 {
  background: #ffea08;
  border: 3px solid rgb(230, 5, 207);
  color: #007bff;
  padding: 10px;
  width: 666px;
}

.three-pane-wrapper {
  border-top: 1px black solid;
  min-height: 800px;
}

.vertical-panes {
  width: 100%;
  height: 400px;
  border: 1px solid red;
}

.vertical-panes > .pane {
  text-align: left;
  padding: 15px;
  overflow: hidden;
  background: #842d2d;
}

.vertical-panes > .pane ~ .pane {
  border-left: 1px solid #34db06;
}

.multipane.foo.layout-v .MultipaneResizer {
  margin: 0;
  left: 0;
  /* reset default styling */
  width: 15px;
  background: blue;
}

.multipane.foo.layout-h .MultipaneResizer {
  margin: 0;
  top: 0;
  /* reset default styling */
  height: 15px;
  background: blue;
}

.custom-resizer {
  width: 100%;
  height: 84vh;
}

.custom-resizer > .pane {
  text-align: left;
  padding: 15px;
  overflow: hidden;
  background: #c6d9c8;
  border: 1px solid #ccc;
}

.custom-resizer > .pane ~ .pane {
  background: #c6d9c8;
}

.custom-resizer > .MultipaneResizer {
  margin: 0;
  left: 0;
  position: relative;

  &:before {
    display: block;
    content: "";
    width: 3px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -1.5px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ff0101;
  }

  &:hover {
    &:before {
      border-color: #999;
    }
  }
}
</style>
